import { FC, PropsWithChildren } from 'react';

import { SnackbarContextProvider } from '@hh.ru/magritte-ui';
import { TipProvider } from 'bloko/blocks/drop';

import Footer from 'src/components/Footer';
import GridContainer, { GridRow, GridColumn } from 'src/components/Grid';
import GridDebug from 'src/components/Grid/GridDebug';
import LogoPrint from 'src/components/LogoPrint';
import MaintenanceMessage from 'src/components/MaintenanceMessage';
import Notifications from 'src/components/Notifications';
import PageIsNotAvailableMessage from 'src/components/PageIsNotAvailableMessage';
import Sidebar from 'src/components/Sidebar';
import Uxfeedback from 'src/components/Uxfeedback';
import useAppBackground from 'src/hooks/useAppBackground';
import { useIsHHru, useIsZP } from 'src/hooks/useSite';
import { useSelector } from 'src/modules/useSelector';

import styles from './page-wrapper.less';

const MAINTENANCE_ALL_PAGES = 'ALL';

const PageWrapper: FC<PropsWithChildren> = ({ children }) => {
    const pageName = useSelector(({ request }) => request.pageName);
    const maintenancePages = useSelector((state) => state.maintenancePages);
    const pageIsNotAvailable = useSelector((state) => state.pageIsNotAvailable);
    const uxfeedback = useSelector((state) => state.uxfeedback);
    const isHH = useIsHHru();
    const isZP = useIsZP();

    useAppBackground();

    const countriesEnabledReports = useSelector(({ countriesEnableReportsList }) => countriesEnableReportsList)?.length;

    const isMaintenance = maintenancePages.includes(MAINTENANCE_ALL_PAGES) || maintenancePages.includes(pageName);
    const currentPageIsNotAvailable = pageIsNotAvailable && pageIsNotAvailable[pageName];

    return (
        <TipProvider>
            <SnackbarContextProvider>
                <Notifications />
                <GridDebug />
                <GridContainer>
                    <GridRow>
                        <GridColumn m="1" l="1" noPrint>
                            {(isHH || (!!countriesEnabledReports && !isZP)) && <Sidebar />}
                        </GridColumn>
                        <GridColumn m="12" l="14">
                            <div className={styles.app}>
                                <div className={styles.appContent}>
                                    <LogoPrint />
                                    {/* eslint-disable-next-line no-nested-ternary */}
                                    {isMaintenance ? (
                                        <MaintenanceMessage />
                                    ) : currentPageIsNotAvailable ? (
                                        <PageIsNotAvailableMessage {...currentPageIsNotAvailable} />
                                    ) : (
                                        children
                                    )}
                                </div>
                                <div className={styles.appFooter}>
                                    <Footer />
                                </div>
                            </div>
                        </GridColumn>
                        <GridColumn m="1" l="1" noPrint />
                    </GridRow>
                </GridContainer>
                {uxfeedback && <Uxfeedback {...uxfeedback} />}
            </SnackbarContextProvider>
        </TipProvider>
    );
};

export default PageWrapper;
